// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.seprate-todo-wrapper {
  padding: 20px;
  max-width: 1200px;
  margin: 0 auto;
}

.seprate-todo-title {
  text-align: center;
  color: #2c3e50;
  margin-bottom: 30px;
  font-size: 2rem;
}

.seprate-todo-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 20px;
}

.seprate-todo-card {
  background: white;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  transition: transform 0.2s ease;
}

.seprate-todo-card:hover {
  transform: translateY(-5px);
}

.seprate-todo-card h3 {
  background: linear-gradient(45deg, #3498db, #2980b9);
  color: white;
  margin: 0;
  padding: 15px;
  font-size: 1.1rem;
  font-weight: 500;
}

.seprate-todo-card p {
  padding: 15px;
  margin: 0;
  font-size: 1.2rem;
  color: #333;
  text-align: center;
}

.loading-message {
  text-align: center;
  padding: 30px;
  color: #7f8c8d;
  font-size: 1.2rem;
}

/* Responsive Design */
@media screen and (max-width: 768px) {
  .seprate-todo-wrapper {
    padding: 15px;
  }

  .seprate-todo-grid {
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: 15px;
  }

  .seprate-todo-card h3 {
    font-size: 1rem;
    padding: 12px;
  }

  .seprate-todo-card p {
    font-size: 1.1rem;
    padding: 12px;
  }
}

@media screen and (max-width: 480px) {
  .seprate-todo-grid {
    grid-template-columns: 1fr;
    gap: 10px;
  }

  .seprate-todo-title {
    font-size: 1.5rem;
  }

  .seprate-todo-card h3 {
    font-size: 0.9rem;
    padding: 10px;
  }

  .seprate-todo-card p {
    font-size: 1rem;
    padding: 10px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/todo.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,wCAAwC;EACxC,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,oDAAoD;EACpD,YAAY;EACZ,SAAS;EACT,aAAa;EACb,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,iBAAiB;EACjB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,iBAAiB;AACnB;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;EACf;;EAEA;IACE,2DAA2D;IAC3D,SAAS;EACX;;EAEA;IACE,eAAe;IACf,aAAa;EACf;;EAEA;IACE,iBAAiB;IACjB,aAAa;EACf;AACF;;AAEA;EACE;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,aAAa;EACf;;EAEA;IACE,eAAe;IACf,aAAa;EACf;AACF","sourcesContent":[".seprate-todo-wrapper {\n  padding: 20px;\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n.seprate-todo-title {\n  text-align: center;\n  color: #2c3e50;\n  margin-bottom: 30px;\n  font-size: 2rem;\n}\n\n.seprate-todo-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  gap: 20px;\n}\n\n.seprate-todo-card {\n  background: white;\n  border-radius: 8px;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  overflow: hidden;\n  transition: transform 0.2s ease;\n}\n\n.seprate-todo-card:hover {\n  transform: translateY(-5px);\n}\n\n.seprate-todo-card h3 {\n  background: linear-gradient(45deg, #3498db, #2980b9);\n  color: white;\n  margin: 0;\n  padding: 15px;\n  font-size: 1.1rem;\n  font-weight: 500;\n}\n\n.seprate-todo-card p {\n  padding: 15px;\n  margin: 0;\n  font-size: 1.2rem;\n  color: #333;\n  text-align: center;\n}\n\n.loading-message {\n  text-align: center;\n  padding: 30px;\n  color: #7f8c8d;\n  font-size: 1.2rem;\n}\n\n/* Responsive Design */\n@media screen and (max-width: 768px) {\n  .seprate-todo-wrapper {\n    padding: 15px;\n  }\n\n  .seprate-todo-grid {\n    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n    gap: 15px;\n  }\n\n  .seprate-todo-card h3 {\n    font-size: 1rem;\n    padding: 12px;\n  }\n\n  .seprate-todo-card p {\n    font-size: 1.1rem;\n    padding: 12px;\n  }\n}\n\n@media screen and (max-width: 480px) {\n  .seprate-todo-grid {\n    grid-template-columns: 1fr;\n    gap: 10px;\n  }\n\n  .seprate-todo-title {\n    font-size: 1.5rem;\n  }\n\n  .seprate-todo-card h3 {\n    font-size: 0.9rem;\n    padding: 10px;\n  }\n\n  .seprate-todo-card p {\n    font-size: 1rem;\n    padding: 10px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
